import { render, staticRenderFns } from "./DirectAccessForm.vue?vue&type=template&id=37e5a524&"
import script from "./DirectAccessForm.js?vue&type=script&lang=js&"
export * from "./DirectAccessForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports